import { defineComponent, nextTick } from 'vue';
import EventBus from '@/EventBus';
export default defineComponent({
  name: 'home-story',
  mounted() {
    EventBus.on('my-falken-home', (evt: any) => {
      if (evt.eventContent === 'falkenAboutUs') {
        nextTick(() => {
          const element = document.getElementById("falkenAboutUs");
          if (element) {
            console.log('Scrolling to:', element);
            const team = element.offsetTop;
            
            window.scrollTo({
              top: team,
              behavior: 'smooth'
            });
          } else {
            console.warn("Element 'falkenAboutUs' not found in the DOM.");
          }
        });
      }
    });
  }
});